import { isPast, isToday } from "date-fns";

export function highlightDeadline(deadline: Date): boolean {
  return isToday(deadline) || isPast(deadline);
}
